<template>
  <div id="app">
    <transition :name="actiBol ? 'slideLeft':'slideRight'">
      <keep-alive>
        <router-view class="appview"></router-view>
      </keep-alive>
    </transition>
    <h5loading v-show="isLoading">快马加鞭中</h5loading>
  </div>
</template>

<script>
import h5loading from "@/components/loading";
import VConsole from 'vconsole/dist/vconsole.min.js' //import vconsole
import { mapState, mapMutations } from "vuex";
export default {
  name: "app",
  components: {
    h5loading
  },
  computed: {
    ...mapState(["isLoading","platformInfo", "actiBol"])
  },
  // watch:{
  //   $route:{
  //     handler:function(val,oldval){
  //       this.HANDLE_TRANCE(val.name);
  //     },
  //     deep:true
  //   }
  // },
  methods:{},
  created () {
    if (process.env.NODE_ENV === 'development') {
      let vConsole = new VConsole() // 初始化
    }
    document.documentElement.style.fontSize = document.documentElement.clientWidth * 2 / 7.5 + 'px';
  }
};
</script>

<style lang="scss">
// 过渡动画
.mint-toast{
  z-index: 9999!important;
}
.appview {
  width: 100%;
  min-height: 100%;
  overflow-y: auto;
}
.slideLeft-enter {
  transform: translate(100%, 0)
}
.slideLeft-enter-active,.slideLeft-leave-active {
  transition: all 0.3s ease-out;
  position: absolute;
  top: 0;
}
.slideLeft-leave-to{
  opacity: 0;
  transform: translate(-50%, 0)
}
.slideRight-enter {
  transform: translate(-100%, 0)
}
.slideRight-enter-active,.slideRight-leave-active {
  transition: all 0.3s ease-out;
  position: absolute;
  top: 0;
}
.slideRight-leave-to{
  opacity: 0;
  transform: translate(50%, 0)
}
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
body,
html {
  background-color: #f4f4f4;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  height: 100%;
  -webkit-tap-highlight-color:rgba(255,255,255,0);
}
#app {
  height: 100%;
  font-size: 0.16rem;
  position: relative;
}
.rb {
  border: solid 1px red;
}
.zidx9999 {
  z-index: 9999!important;
}
/* page{
  background-color: #f4f4f4;
} */

page {
  background: rgba(247, 247, 247, 1);
}

view {
  box-sizing: border-box;
}
.cell {
  width: 3.55rem;
  height: 0.5rem;
  background: rgba(255, 255, 255, 1);
  padding-left: 0.17rem;
  padding-right: 0.17rem;
  // display: flex;
  // align-items: center;
  justify-content: space-between;
}
.cell-title {
  display: inline-block;
  color: #666666;
  font-size: 0.14rem;
  line-height: 0.5rem;
  width: auto;
}
.cell-up {
  border-radius: 0.06rem 0.06rem 0px 0px;
  margin-top: 0.1rem;
}
.cell-down {
  border-radius: 0px 0px 0.06rem 0.06rem;
}
.cell-content {
  float: right;
  line-height: 0.5rem;
  font-size: 0.14rem;
  /* flex: 1;
  text-align: right; */
}
.price-in-cell {
  float: right;
  line-height: 0.5rem;
}
.price {
  color: #ff9711;
  display: inline-block;
}
.button-container {
  width: 100vw;
  height: 0.6rem;
  position: fixed;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 0.16rem 0px rgba(211, 211, 211, 0.5);
  box-sizing: border-box;
  font-size: 0.16rem;
}

.point {
  width: 0.07rem;
  height: 0.12rem;
}
</style>
